import { render, staticRenderFns } from "./ConfirmationDialogInputAndFile.vue?vue&type=template&id=3da477de"
import script from "./ConfirmationDialogInputAndFile.vue?vue&type=script&lang=js"
export * from "./ConfirmationDialogInputAndFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports